import React from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';
import {
  maxMobile,
  maxTablet,
  minWidthApp,
  nextButtonSlider, previousButtonSlider, primaryColor, primaryFont, smMobile, wMedium,
} from 'Utils/utilsStyle';
import SliderEmailing from 'Components/common/assets/sliderImages/SliderEmailing.png';
import SliderEmailingActive from 'Components/common/assets/sliderImages/SliderEmailingActive.png';
import SliderSelling from 'Components/common/assets/sliderImages/SliderSelling.png';
import SliderSellingActive from 'Components/common/assets/sliderImages/SliderSellingActive.png';
import SliderCommunication from 'Components/common/assets/sliderImages/SliderCommunication.png';
import SliderCommunicationActive from 'Components/common/assets/sliderImages/SliderCommunicationActive.png';
import SliderWorking from 'Components/common/assets/sliderImages/SliderWorking.png';
import SliderWorkingActive from 'Components/common/assets/sliderImages/SliderWorkingActive.png';
import SliderMotivators from 'Components/common/assets/sliderImages/SliderMotivators.png';
import SliderMotivatorsActive from 'Components/common/assets/sliderImages/SliderMotivatorsActive.png';
import SliderBehavior from 'Components/common/assets/sliderImages/SliderBehavior.png';
import SliderBehaviorActive from 'Components/common/assets/sliderImages/SliderBehaviorActive.png';
import SliderStrength from 'Components/common/assets/sliderImages/SliderStrength.png';
import SliderStrengthActive from 'Components/common/assets/sliderImages/SliderStrengthActive.png';
import { PersonInsights } from 'Types/PersonTypes';
import SliderContent from './SliderContent';

type Props = {
  sliderData: PersonInsights[],
  personalityColor?: string,
} & typeof defaultProps;

const defaultProps = {
  personalityColor: '',
};

const TimeLineWrapper = styled.div<{ titleName: string[] }>`
  .slider-wrapper-custom {
    margin-bottom: 0px;
    height: 100%;
    > .slick-list {
      > {
        .slick-track {
          margin-left:0;
        }
      }
    }
    .slick-disabled {
      display: none !important;
    }
    .slick-arrow {
      &.slick-prev {
        z-index: 1;
        &:before {
          height: 40px;
          width: 28px;
          background-size: contain;
          background-repeat: no-repeat;
          background-image: url(${previousButtonSlider});
          content: '';
          position: absolute;
          top: 0px;
          left: -25px;
          @media all and (max-width: ${minWidthApp}) and (min-width: ${maxTablet}) {
            width: 20px;
            height: 30px;
            left: 10px;
          }
          @media all and (max-width: ${maxTablet}) {
            left: 10px;
            height: 20px;
            width: 20px;
          }
        }
      }
      &.slick-next {
        &:before {
          height: 40px;
          width: 28px;
          background-size: contain;
          background-repeat: no-repeat;
          background-image: url(${nextButtonSlider});
          content: '';
          position: absolute;
          top: 0px;
          right: -28px;
          @media all and (max-width: ${minWidthApp}) and (min-width: ${maxTablet}) {
            width: 20px;
            height: 30px;
            right: 8px;
          }
          @media all and (max-width: ${maxTablet}) {
            right: 10px; 
            height: 20px;
            width: 20px;
          }
        }
  
      }
    }
  }
  .slick-track {
    padding-top: 160px; 
    @media all and (max-width: ${maxMobile}){
      padding-top: 55px;
    }
  }
  .slick-slider {
    min-height: 410px;
    @media all and (max-width: ${maxMobile}){
      min-height: auto;
    }
  }
  .slick-dots {
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    padding: 0px 70px 0px 40px;
    top: -50px;
    height: 186px;
    @media all and (max-width: ${minWidthApp}){
      padding: 0px 10px 0px 0px;
    }
    @media all and (max-width: ${maxMobile}){
      height: 50px;
    }
    &:after {
      content: '';
      height: 3px;
      background-color: ${primaryColor};
      width: 92%;
      left: 50px;
      position: absolute;
      z-index: 1;
      @media all and (max-width: 1835px){
        width: 90%;
      }
      @media all and (max-width: 1555px){
        width: 86%;
      }
      @media all and (max-width: ${minWidthApp}){
        width: 88%;
      }
      @media all and (max-width: ${maxMobile}){
        width: 95%;
        left: 10px;
        top: 26px;
      }
      @media all and (max-width: ${smMobile}){
        width: 95%;
        left: 5px;
        top: 27px;
      }
    }
    li {
     height: 54px;
     width: 54px;
     z-index: 2;
     @media all and (max-width: ${maxMobile}){
      height: 10px;
      width: 10px; 
     }
      button {
        &:after {
          letter-spacing: -0.33px;
          line-height: 20px;
          color: #67696A;
          font-weight: ${wMedium};
          font-family: ${primaryFont};
          font-size: 16px;
          left: 50%;
          position: absolute;
          top: 60px;
          width: 140px;
          transform: translate(-50%, 10px);
          @media all and (max-width: ${maxTablet}) {
            font-size: 10px;
          }
          @media all and (max-width: ${maxMobile}) {
            top: 15px;
            max-width: 55px;
            line-height: 12px;
          }
          @media all and (max-width: ${smMobile}) {
            font-size: 8px;
          }
        }
        &:before {
          opacity: 1;
          @media all and (max-width: ${maxMobile}){
           display: none;
          }
        }
        &:hover {
          &:after {
            color: ${primaryColor};
          }
        }
      }
      &:nth-child(1) {
        button {
          &:before {
            content: '';
            height: 27px;
            width: 32px;
            left: 8px;
            top: 10px;
            background-image: url(${SliderBehavior});
            background-size: cover;
            background-position: center;
          }
          &:after {
            content: "${(props) => props.titleName[0]}";
          }
        }
      }
      &:nth-child(2) {
        button {
          &:before {
            content: '';
            height: 30px;
            width: 20px;
            left: 13px;
            top: 8px;
            background-image: url(${SliderMotivators});
            background-size: cover;
            background-position: center;
          }
          &:after {
            content: "${(props) => props.titleName[1]}";
          }
        }
      }
      &:nth-child(3) {
        button {
          &:before {
            content: '';
            height: 29px;
            width: 33px;
            left: 7px;
            top: 10px;
            background-image: url(${SliderWorking});
            background-size: cover;
            background-position: center;
          }
          &:after {
            content: "${(props) => props.titleName[2]}";
            @media all and (max-width: ${maxMobile}) {
              max-width: 40px;
            }
          }
        }
      }
      &:nth-child(4) {
        button {
          &:before {
            content: '';
            height: 25px;
            width: 28px;
            left: 11px;
            top: 11px;
            background-image: url(${SliderCommunication});
            background-size: cover;
            background-position: center;
          }
          &:after {
            content: "${(props) => props.titleName[3]}";
          }
        }
      }
      &:nth-child(5) {
        button {
          &:before {
            content: '';
            left: 11px;
            top: 10px;
            height: 26px;
            width: 26px;
            background-image: url(${SliderEmailingActive});
            background-size: cover;
            background-position: center;
          }
          &:after {
            content: "${(props) => props.titleName[4]}";
          }
        }
      }
      &:nth-child(6) {
        button {
          &:before {
            content: '';
            left: 8px;
            top: 8px;
            height: 30px;
            width: 33px;
            background-image: url(${SliderSelling});
            background-size: cover;
            background-position: center;
          }
          &:after {
            content: "${(props) => props.titleName[5]}";
          }
        }
      }
       &:nth-child(7) {
        button {
          &:before {
            content: '';
            height: 25px;
            width: 30px;
            left: 9px;
            top: 11px;
            background-image: url(${SliderStrength});
            background-size: cover;
            background-position: center;
          }
          &:after {
            content: "${(props) => props.titleName[6]}";
             @media all and (max-width: ${maxMobile}) {
              padding-right: 8px;
             }
          }
        }
      }
      &.slick-active {
        button {
          background-color: ${primaryColor};
        }
        &:nth-child(1) {
          button {
            &:before {
            background-image: url(${SliderBehaviorActive});
            }
          }
        }
        &:nth-child(2) {
          button {
            &:before {
            background-image: url(${SliderMotivatorsActive});
            }
          }
        }
        &:nth-child(3) {
          button {
            &:before {
            background-image: url(${SliderWorkingActive});
            }
          }
        }
        &:nth-child(4) {
          button {
            &:before {
            background-image: url(${SliderCommunicationActive});
            }
          }
        }
        &:nth-child(5) {
          button {
            &:before {
            background-image: url(${SliderEmailing});
            }
          }
        }
        &:nth-child(6) {
          button {
            &:before {
            background-image: url(${SliderSellingActive});
            }
          }
        }
        &:nth-child(7) {
          button {
            &:before {
            background-image: url(${SliderStrengthActive});
            }
          }
        }
      }
     button {
      background: #fff;
      border: 3px solid ${primaryColor};
      height: 100%;
      width: 100%;
      border-radius: 100px;
      position: relative;
     }
    }
  }
`;

const TimeLineSlider = function TimeLineSlider(props: Props) {
  const { sliderData, personalityColor } = props;

  const personalitySliderControls = {
    dots: true,
    infinite: true,
    speed: 200,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    fade: true,
    cssEase: 'linear',
    pauseOnDotsHover: true,
  };

  const makeSteps = () => sliderData.map((d: PersonInsights) => (
    <SliderContent
      topicHeading={d.title}
      topicDescription={d.description}
      insightData={d.insightData || []}
      tipsItemColor={personalityColor}
    />
  ));

  const titleReturn = () => sliderData.map((d: PersonInsights) => d.title);
  return (
    <TimeLineWrapper titleName={titleReturn()}>
      <Slider {...personalitySliderControls} className="slider-wrapper-custom">
        {makeSteps()}
      </Slider>
    </TimeLineWrapper>
  );
};

TimeLineSlider.defaultProps = defaultProps;
export default TimeLineSlider;
